{
  "Dashboard": "Panel",
  "BlyCareShippingProte": "Protección de envío BlyCare",
  "LoadingBlyCare": "Cargando BlyCare…",
  "LoadingWidgetSetting": "Cargando ajustes del widget…",
  "PreparingYourWorkspa": "Preparando tu espacio de trabajo",
  "Language": "Idioma",
  "English": "English",
  "EnglishDefault": "English (predeterminado)",
  "German": "Deutsch",
  "Spanish": "Español",
  "French": "Français",
  "Italian": "Italiano",
  "Japanese": "日本語",
  "Korean": "한국어",
  "Dutch": "Nederlands",
  "Polish": "Polski",
  "Portuguese": "Português",
  "Ukrainian": "Українська",
  "SimplifiedChinese": "简体中文",
  "TraditionalChinese": "繁體中文",
  "SetupGuide": "Guía de configuración",
  "CompletedOfTotalComp": "{{completed}} de {{total}} completados",
  "Dismiss": "Descartar",
  "MoreActions": "Más acciones",
  "ToggleSetupGuide": "Mostrar u ocultar la guía de configuración",
  "ActivateAppEmbed": "Activar app embed",
  "ClickTheEnableButton": "1. Haz clic en el botón Activar que aparece abajo para abrir el editor de temas de Shopify.",
  "BlyCareEmbedSection": "2. Busca BlyCare en la sección App embed de la izquierda. Asegúrate de que su interruptor esté activado. Después, haz clic en Guardar en la esquina superior derecha.",
  "Enable": "Activar",
  "PublishWidget": "Publicar widget",
  "PublishStorefront": "Publica el widget en tu tienda online para que los clientes puedan comprarlo.",
  "Publish": "Publicar",
  "SetProtectionFee": "Configurar la tarifa de protección",
  "FeeYouWantToCharge": "Configura la tarifa que quieres cobrar a los clientes.",
  "Setup": "Configurar",
  "TestYourWidgetOnYour": "Prueba tu widget en tu tienda",
  "AddAProductToYourCar": "Añade un producto al carrito y comprueba que aparezca el widget de protección de envío. Selecciona la protección de envío, continúa al pago y asegúrate de que el producto de protección de envío aparezca en la página de pago.",
  "TestNow": "Probar ahora",
  "Working": "Todo correcto",
  "NeedHelp": "¿Necesitas ayuda?",
  "MarkAsCompleted": "Marcar como completado",
  "AppStatus": "Estado de la app",
  "AppEmbed": "App embed",
  "EnableAppEmbedToDisp": "Activa app embed para mostrar la protección de envío en el carrito.",
  "CartPage": "Mostrar la protección de envío en la página del carrito.",
  "CheckoutBlock": "Bloque de pago",
  "CheckoutPage": "Mostrar la protección de envío en la página de pago.",
  "Active": "Activo",
  "Inactive": "Inactivo",
  "Analytics": "Analíticas",
  "Today": "Hoy",
  "Last7Days": "Últimos 7 días",
  "Last30Days": "Últimos 30 días",
  "Last60Days": "Últimos 60 días",
  "Last90Days": "Últimos 90 días",
  "Last365Days": "Últimos 365 días",
  "Custom": "Personalizado",
  "Start": "Inicio",
  "End": "Fin",
  "DateRange": "Rango de fechas",
  "SelectedRange": "Rango seleccionado: {{range}}",
  "Cancel": "Cancelar",
  "Save": "Guardar",
  "ChooseAStartDateOnOr": "Elige una fecha de inicio igual o anterior a la fecha de fin y no selecciones un día posterior a hoy.",
  "PreviousMonth": "Mes anterior",
  "NextMonth": "Mes siguiente",
  "ProtectionRevenue": "Ingresos por protección",
  "ProtectedOrders": "Pedidos protegidos",
  "ProtectedOrderRate": "Tasa de pedidos protegidos",
  "LoadingAnalytics": "Cargando analíticas…",
  "AnalyticsCouldNotLo": "No se pudieron cargar las analíticas",
  "RetryAnalytics": "Reintentar analíticas",
  "Resources": "Recursos",
  "HowDoesShippingProte": "¿Cómo funciona la protección de envío?",
  "BlyCareAddsAShipping": "BlyCare añade un widget de protección de envío al carrito. Los clientes pueden elegir añadir protección a sus pedidos. El comerciante cobra la tarifa de protección, decide qué situaciones están cubiertas y usa esas tarifas para resolver las reclamaciones.",
  "DoesBlyCareCoverInsu": "¿BlyCare cubre reclamaciones de seguro?",
  "NoBlyCareIsNotInsura": "No. BlyCare no es un seguro ni paga reclamaciones. BlyCare solo proporciona el widget y las herramientas para que los comerciantes gestionen su propio programa de protección de envío.",
  "EmailUs": "Envíanos un correo",
  "LiveChat": "Chat en vivo",
  "HelpCenter": "Centro de ayuda",
  "Settings": "Ajustes",
  "CheckoutWidget": "Widget de pago",
  "CartWidget": "Widget del carrito",
  "PriceSetting": "Ajuste de precio",
  "ProductSetting": "Ajuste de producto",
  "AdminLanguage": "Idioma del administrador",
  "AdminLanguageTitle": "Idioma del administrador",
  "AdminLanguageHelp": "Cambia el idioma de la app solo para ti. Los clientes no se ven afectados.",
  "AppLanguage": "Idioma de la app",
  "UnableToLoadSettings": "No se pudieron cargar los ajustes",
  "TryAgain": "Reintentar",
  "Discard": "Descartar",
  "LoadingSettings": "Cargando ajustes",
  "PageNotFound": "Página no encontrada",
  "ProductSettingsCould": "No se pudieron guardar los ajustes del producto.",
  "Fulfillment": "Preparación del pedido",
  "FulfillmentHelp": "Elige cuándo se marca el producto de protección como preparado.",
  "ManuallyFulfill": "Preparar manualmente",
  "MarkFulfilledWhenFir": "Marcar como preparado cuando se prepare el primer artículo del pedido",
  "MarkFulfilledWhenAll": "Marcar como preparado cuando se preparen todos los demás artículos del pedido",
  "MarkFulfilledImmedi": "Marcar como preparado inmediatamente después de crear el pedido",
  "Exclusions": "Exclusiones",
  "ExclusionsHelp": "Elige cuándo no debe aplicarse la protección.",
  "ExclusionType": "Tipo de exclusión",
  "Select": "Seleccionar",
  "SelectedExclusions": "Exclusiones seleccionadas",
  "RemoveName": "Eliminar {{name}}",
  "WhenExcluded": "Cuando se excluya",
  "HideWidget": "Ocultar widget",
  "KeepWidgetButSkipThe": "Mantener el widget pero omitir la tarifa",
  "ExcludeProductType": "Excluir tipo de producto",
  "SearchProductType": "Buscar tipo de producto",
  "ExcludeSKU": "Excluir SKU",
  "SearchSKU": "Buscar SKU",
  "ExcludeCollection": "Excluir colección",
  "SearchCollection": "Buscar colección",
  "ExcludeMarket": "Excluir mercado",
  "SearchMarket": "Buscar mercado",
  "ExcludeLanguage": "Excluir idioma",
  "SearchLanguage": "Buscar idioma",
  "Add": "Añadir",
  "PriceSettingsCouldNo": "No se pudieron guardar los ajustes de precios.",
  "ShippingProtectionPr": "Precio de la protección de envío",
  "SetHowMuchPriceDoYou": "Configura cuánto cobrar al cliente",
  "PricingMethod": "Método de precio",
  "Fixed": "Fijo",
  "Percentage": "Porcentaje",
  "UniversalProtectionP": "Precio de protección universal",
  "PercentageOfCartSubt": "Porcentaje del subtotal del carrito",
  "EditCappedPrice": "Editar precio máximo",
  "ShippingProtectionFe": "Tarifa de protección de envío por porcentaje desde {{minPrice}} USD, con incrementos de {{increment}} USD, hasta un máximo de {{capped}} USD.",
  "MinProtectionFee": "Tarifa de protección mínima",
  "IncrementAmount": "Importe del incremento",
  "CappedProtectionFee": "Tarifa de protección máxima",
  "AddTierPrice": "Añadir precio por tramos",
  "AddTier": "Añadir tramo",
  "TierPriceHelp": "Si el precio del carrito no coincide con ninguno de los rangos de precios por tramos, se aplicará el precio universal configurado en la página anterior.",
  "MinCartPrice": "Precio mínimo del carrito",
  "MaxCartPrice": "Precio máximo del carrito",
  "ProtectionFee": "Tarifa de protección",
  "RemoveTier": "Eliminar tramo",
  "Required": "Obligatorio",
  "ThisFieldIsRequired": "Este campo es obligatorio.",
  "MustBeGreaterThanZero": "{{label}} debe ser mayor que 0.",
  "MustBeOrLess": "{{label}} debe ser {{max}} o menos.",
  "AtMostTwoDecimals": "{{label}} puede tener como máximo 2 decimales.",
  "MustBeLargerThanMinC": "Debe ser mayor que el precio mínimo del carrito",
  "MustBeLargerThanMaxC": "Debe ser mayor que el precio máximo del carrito",
  "MustBeSmallerThanMin": "Debe ser menor que el precio mínimo del carrito",
  "Price": "Precio",
  "MinimumPrice": "Precio mínimo",
  "Increment": "Incremento",
  "CartPageWidget": "Widget de la página del carrito",
  "CheckoutPageWidget": "Widget de la página de pago",
  "WidgetFormat": "Formato del widget",
  "TickerWidget": "Widget estándar",
  "CheckoutButtonWidget": "Widget de botón de pago",
  "Text": "Texto",
  "MainText": "Texto principal",
  "Title": "Título",
  "Description": "Descripción",
  "MainButtonText": "Texto del botón principal",
  "SecondaryButtonText": "Texto del botón secundario",
  "EnabledDescription": "Descripción activada",
  "DisabledDescription": "Descripción desactivada",
  "PleaseEnterTitle": "Introduce el título",
  "PleaseEnterDescript": "Introduce la descripción",
  "PleaseEnterMainButt": "Introduce el texto del botón principal",
  "PleaseEnterSecondar": "Introduce el texto del botón secundario",
  "PleaseEnterEnabledD": "Introduce la descripción activada",
  "PleaseEnterDisabled": "Introduce la descripción desactivada",
  "EGViewTerms": "p. ej., Ver términos",
  "EGHttpTerms": "p. ej., https://terms.com",
  "Footer": "Pie de página",
  "FooterText": "Texto del pie de página",
  "FooterLink": "Enlace del pie de página",
  "TooltipLink": "Enlace del tooltip",
  "FooterVisibility": "Visibilidad del pie de página",
  "TitleInfoVisibility": "Visibilidad de la información del título",
  "Disabled": "Desactivado",
  "Enabled": "Activado",
  "Color": "Color",
  "ColorStyle": "Estilo de color",
  "SizeAndDisplay": "Tamaño y visualización",
  "IconSize": "Tamaño del icono",
  "IconRadius": "Radio del icono",
  "BorderSize": "Tamaño del borde",
  "BorderRadius": "Radio del borde",
  "HorizontalPadding": "Relleno horizontal",
  "VerticalPadding": "Relleno vertical",
  "ToggleFormat": "Formato del interruptor",
  "Switch": "Interruptor",
  "Checkbox": "Casilla de verificación",
  "Border": "Borde",
  "Background": "Fondo",
  "ProtectionDescript": "Descripción de la protección",
  "MainButtonBackgrou": "Fondo del botón principal",
  "EnabledToggle": "Interruptor activado",
  "DisabledToggle": "Interruptor desactivado",
  "Automatic": "Automático",
  "Neutral": "Neutro",
  "Info": "Información",
  "Success": "Éxito",
  "Warning": "Advertencia",
  "Critical": "Crítico",
  "Subdued": "Atenuado",
  "Transparent": "Transparente",
  "ThemeColor": "Color del tema",
  "ResetToDefaultColor": "{{label}}: restablecer el color predeterminado",
  "OpenColorPicker": "{{label}}: abrir selector de color",
  "Icon": "Icono",
  "PackageIcon": "Icono de paquete",
  "PackageIconNumber": "Icono de paquete {{value}}",
  "UploadIcon": "Subir icono",
  "NoIcon": "Sin icono",
  "AcceptedFormats": "Formatos aceptados: PNG, JPG, SVG",
  "MaximumFileSize": "Tamaño máximo del archivo: 50 MB",
  "AddFiles": "Añadir archivos",
  "RemoveImage": "Eliminar imagen",
  "Uploading": "Subiendo",
  "UploadFailedTryAgain": "Error al subir. Inténtalo de nuevo.",
  "ChooseAJPEGPNG": "Elige una imagen JPEG, PNG o SVG de hasta 50 MB.",
  "ChooseNonemptyImage": "Elige una imagen JPEG, JPG, PNG o SVG no vacía de hasta 50 MB.",
  "ImageCouldNotBeRead": "No se pudo leer la imagen.",
  "FileContentsMismatch": "El contenido del archivo debe coincidir con su tipo de imagen JPEG, PNG o SVG.",
  "ImageCouldNotBeDecode": "No se pudo decodificar la imagen.",
  "InvalidImageUrl": "El servicio de carga devolvió una URL de imagen no válida.",
  "MissingPublicImageUrl": "El servicio de carga no devolvió una URL de imagen pública.",
  "CustomCssTooLong": "El CSS personalizado puede tener como máximo 2000 caracteres.",
  "ChooseValidIconUrl": "Elige un icono subido con una URL válida.",
  "EnterNumberRange": "Introduce un número de {{min}} a {{max}}.",
  "EnterLocaleTextRange": "Introduce el texto de {{locale}} entre 1 y {{limit}} caracteres.",
  "EnterValidLearnMoreUrl": "Introduce una URL válida de Más información que empiece por https:// o http://.",
  "ReviewHighlightedFields": "Revisa los campos resaltados.",
  "CannotChangePublishState": "No se puede cambiar el estado de publicación hasta que el formulario sea válido: {{reason}}",
  "BlyCareCouldNotSave": "BlyCare no pudo guardar.",
  "CheckoutRequiresPlus": "La personalización del pago requiere Shopify Plus.",
  "SaveSucceededReloadFailed": "La solicitud de guardado se realizó correctamente, pero no se pudieron cargar los ajustes más recientes del widget. Actualiza para comprobar los cambios.",
  "BlyCareCouldNotComplete": "BlyCare no pudo completar esta solicitud.",
  "ShopifyAuthorizationRequired": "Se requiere la autorización de Shopify.",
  "AppBridgeUnavailable": "Shopify App Bridge no está disponible",
  "ExtensionStatusUnavailable": "El estado de la extensión de Shopify no está disponible.",
  "ConfigurationPreview": "Vista previa de la configuración",
  "On": "Activado",
  "Off": "Desactivado",
  "Unpublish": "Anular publicación",
  "AppEmbedIsNotEnable": "La app embed no está activada.",
  "GoEnabled": "Ir a Activar",
  "ViewOnYourStorefront": "Ver en tu tienda online",
  "PreviewProtection": "Vista previa de la protección",
  "MoreInformation": "Más información",
  "Cart": "Carrito",
  "Subtotal": "Subtotal",
  "Checkout": "Finalizar compra",
  "DiscountCode": "Código de descuento",
  "Apply": "Aplicar",
  "Shipping": "Envío",
  "Total": "Total",
  "ShippingProtection": "Protección de envío",
  "Product": "Producto",
  "CopyLink": "Copiar enlace"
}
